/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'

import { Control, ControlResolver, FieldsComponent } from 'superlikers-dynamic-forms'

import { PasswordService } from '@auth/services/password.service'
import { resetPasswordControls } from './data'
import { environment } from '../../../../environments/environment'

@Component({
  selector: 'app-reset-password-page',
  standalone: true,
  imports: [ReactiveFormsModule, FieldsComponent],
  templateUrl: './reset-password-page.component.html',
  styleUrl: './reset-password-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetPasswordPageComponent {
  passwordService = inject(PasswordService)
  controlResolver = inject(ControlResolver)

  form = new FormGroup({})
  controls: Control[] = resetPasswordControls

  successMessage = signal<string>('')
  errorMessage = signal<string>('')

  loading = signal<boolean>(false)

  async submit() {
    this.successMessage.set('')
    this.errorMessage.set('')

    if (this.form.invalid) return

    this.loading.set(true)

    const values = this.form.value as Record<string, string>
    const { uid, email } = values

    const channel = 'email'
    const redirectUrl = this.getRedirectUrl()
    const data = { email, uid } as Record<string, string>

    try {
      const response = await this.passwordService.sendToken(channel, data, redirectUrl)

      if (response.state === 'success') {
        this.successMessage.set(response.message)
      } else {
        this.errorMessage.set(response.message)
      }
    } catch (err: any) {
      this.errorMessage.set(err.error.message)
    } finally {
      this.loading.set(false)
    }
  }

  getRedirectUrl() {
    const id = environment.id
    const url = `${id}/password/edit`

    return url
  }
}
